export const textVariant = (delay) => {
	return {
		hidden: {
			y: 20,
			opacity: 0,
		},
		show: {
			y: 0,
			opacity: 1,
			transition: {
				type: 'tween',
				duration: 0.4,
				delay: delay || 0,
				ease: 'easeOut',
			},
		},
	};
};

export const fadeIn = (direction, type, delay, duration) => {
	return {
		hidden: {
			x: direction === 'left' ? 40 : direction === 'right' ? -40 : 0,
			y: direction === 'up' ? 40 : direction === 'down' ? -40 : 0,
			opacity: 0,
		},
		show: {
			x: 0,
			y: 0,
			opacity: 1,
			transition: {
				type: type || 'tween',
				delay: delay,
				duration: duration || 0.4,
				ease: 'easeOut',
			},
		},
	};
};

export const slideIn = (direction, type, delay, duration) => {
	return {
		hidden: {
			x: direction === 'left' ? '-60px' : direction === 'right' ? '60px' : 0,
			y: direction === 'up' ? '60px' : direction === 'down' ? '60px' : 0,
			opacity: 0,
		},
		show: {
			x: 0,
			y: 0,
			opacity: 1,
			transition: {
				type: type || 'tween',
				delay: delay,
				duration: duration || 0.4,
				ease: 'easeOut',
			},
		},
	};
};

export const staggerContainer = (staggerChildren, delayChildren) => {
	return {
		hidden: {},
		show: {
			transition: {
				staggerChildren: staggerChildren || 0.08,
				delayChildren: delayChildren || 0,
			},
		},
	};
};
